"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["PURCHASE"] = "purchase";
    TransactionType["REFINANCE"] = "refinance";
    TransactionType["HOME_EQUITY"] = "home-equity";
    TransactionType["HOME_EQUITY_TURBO"] = "home-equity-turbo";
    TransactionType["PURCHASE_TURBO"] = "purchase-turbo";
    TransactionType["REFINANCE_TURBO"] = "refinance-turbo";
    TransactionType["REVERSE"] = "reverse";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
